import { cn } from "@tellescope/ui";
import { DAY_COLUMN } from "../constants";
import { useDateFnsFormattersWithLocale } from "@tellescope/ui";

export interface TimeColumnHeaderProps {
  startDate: Date;
  timezone: string;
  browserTimezone: string;
  showTwoTimezones: boolean;
  className?: string;
}

export const TimeColumnHeader = ({
  startDate,
  timezone,
  browserTimezone,
  showTwoTimezones,
  className,
}: TimeColumnHeaderProps) => {
  const { formatInTimeZone } = useDateFnsFormattersWithLocale();

  return (
    <div
      className={cn(
        "flex flex-col justify-center gap-0 items-end text-[10px] font-light px-2 border-b border-b-gray-200",
        className
      )}
      style={{ minWidth: DAY_COLUMN.LEFT_COLUMN_WIDTH }}
    >
      <span className="text-muted-foreground">{formatInTimeZone(startDate, timezone, "zzz")}</span>
      {showTwoTimezones && (
        <span className="text-muted-foreground/50">{formatInTimeZone(startDate, browserTimezone, "zzz")}</span>
      )}
    </div>
  );
};
